import questions from '@/components/ComQuestions.vue';
import store from '@/store';
import _ from 'lodash';
import mem from '@/service/member';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lineChart from '@/components/lineChart.vue';
import publicfooter from '@/components/footer.vue';
import comlogin from '@/components/ComLogin.vue';
import analyzeItem from '@/components/analyzeItem.vue'

export default {
  name: 'exam',
  data() {
    return {
      isLoading: false,
      fullPage: true,
      min: 0,
      later: '',
      qkeyf: 1,
      qkeyf2: 1,
      isOver: false,
      tip: false,
      reload: false,
      showMoreInfo: false,
      openAna: false,
      openAns: false,
      ansStatus: [],
      tempTag: [],
      showAnsCard: true,
      // unit_code_ob: {},
      // unit_code: [],
      // stopTimes: false,
      scrollshow: {
        opacity: 0,
        visibility: 'hidden'
      },
      examTitle: {
        name:'',
        phoneName:''
      }
    };
  },
  props: {
    selected: {},
  },
  components: {
    questions,
    Loading,
    lineChart,
    publicfooter,
    comlogin,
    analyzeItem
  },
  methods: {
    openAnsCard() {
      if (this.showAnsCard) {
        this.showAnsCard = false;
      } else {
        this.showAnsCard = true;
      }
    },

    emitTag(data) {
      this.tempTag = data;
    },
    retime() {
      const now = this.$moment().set('hour', 0);
      now.set('minute', 0);
      now.set('second', 0);
      if (this.$route.params.type == "C") {
        this.later = now.add(1, 'h');
      } else {
        this.later = now.add(1, 'h');
        this.later = now.add(20, 'm');
      }
    },
    ChangeAllwaysAns(data) {
      const traget = data;
      const h = this.$createElement;
      // '您的作答記錄即將清空，測驗時間： ' + this.times + ' 分鐘'
      const boxtext = h('div', { class: ['px-lg-5', 'px-3', 'py-2']}, [
        h('div', { class: ['d-flex'] }, [
          h('span', { class: ['pr-3', 'text-deepgold'] }, '作答模式'), 
          h('span', { class: ['px-1'] }, '計時交卷'),
        ]),
        h('div', { class: ['d-flex', 'mt-2', 'pt-2'] }, [
          h('span', { class: ['pr-3', 'text-deepgold'] }, '測驗時間'),
          h('span', { class: ['px-1'] }, [
            h('strong', this.times),
            ' 分鐘 ',
          ]),
        ]),
      ]);
      if (this.allwaysAns && traget === 'hideAns') {
        this.$bvModal.msgBoxConfirm(boxtext, {
          title: '重新測驗',
          okTitle: '開始測驗',
          cancelTitle: '取消',
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'deepgold',
          cancelVariant: 'light',
          headerClass: 'px-2 pt-4 border-bottom-0 text-center',
          titleClass: 'mx-auto py-1 border-bottom border-deepgold border-b-3 text-deepgold h5',
          bodyClass: 'pt-1 border-bottom-0 text-left',
          footerClass: 'p-2 border-top-0',
          centered: true
        }).then((value) => {
          if (value) {
            this.$store.commit('exam/setAllwaysAns', false);
            this.retime();
            this.$store.commit('exam/setTimes', false);
            this.$store.commit('exam/saveFinish', {
              tf: false,
              cancelVariant: 'light',
            });
            this.$store.commit('exam/clearAns');
            this.reload = true;
            this.countdownTimes();
            this.openAna = false;
            this.openAns = false;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          } else {
            this.$store.commit('exam/setAllwaysAns', true);
          }
        });
      } else {
        if (traget === 'showAns'){
          this.$store.commit('exam/saveFinish', {
            tf: false,
          });
        }
        this.$store.commit('exam/setAllwaysAns', true);
        this.countdownTimes();
        // this.$store.commit('exam/setTimes', false);
      }
    },
    handleScroll() {
      const bodyheight = window.scrollMaxY || document.documentElement.scrollHeight || document.body
        .scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
        .scrollTop;
      if (scrollTop > 30) {
        this.scrollshow.opacity = 0.8;
        this.scrollshow.visibility = 'visible';
      }
      if (scrollTop > bodyheight - 1000) {
        this.scrollshow.opacity = 0;
        this.scrollshow.visibility = 'hidden';
      }
    },
    login() {
      this.$bvModal.show('modal-login');
    },
    reloadPage() {
      // const now = this.$moment().set('hour', 0);
      // now.set('minute', 0);
      // now.set('second', 0);
      // this.later = now.add(1, 'h');
      // this.later = now.add(20, 'm');
      this.retime();
      this.$store.commit('exam/setTimes', false);
      this.$store.commit('exam/saveFinish', {
        tf: false,
      });
      this.$store.commit('exam/clearAns');
      this.reload = true;
      this.countdownTimes();
    },
    showMsgBoxOne() {
      this.$store.dispatch('exam/checkFinish');
      this.$bvModal.msgBoxConfirm(this.message1, {
        okTitle: '確定',
        cancelTitle: '取消',
        size: 'sm',
        buttonSize: 'md',
        okVariant: 'deepgold',
        cancelVariant: 'light',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      }).then((value) => {
        if (value) {
          this.$store.dispatch('exam/calculationScore');
          this.$store.commit('exam/setTimes', true);
          this.$store.commit('exam/saveFinish', {
            tf: true,
          });
          this.$store.dispatch('exam/check', false);
          this.reload = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        } else {
          this.$store.commit('exam/setTimes', false);
          this.$store.commit('exam/saveFinish', {
            tf: false,
          });
        }
      });
    },
    toWithout() {
      for (let i = 0; i <= this.totalQuestion; i += 1) {
        if (this.single) {
          if ((!this.allwaysAns && !this.selectedAns[i]) || (this.allwaysAns && !this.selectedStatus[i])) {
            this.qkeyf = i + 1;
            this.qkeyf2 = i + 1;
            break;
          }
        } else if ((!this.allwaysAns && !this.selectedAns[i]) || (this.allwaysAns && !this.selectedStatus[i])) {
          this.$scrollTo(`#__q${i + 1}`, 500, {
            offset: -130,
          });
          this.qkeyf = i + 1;
          break;
        }
      }
    },
    getqkey(data) {
      this.qkeyf = data;
    },
    getqkey2(data) {
      this.qkeyf2 = data;
    },
    quick_setQ(index, index2) {
      this.qkeyf = index;
      this.qkeyf2 = index2 + 1;
    },
    countdownTimes() {
      if (!this.allwaysAns) {
        if (!this.stopTimes) {
          if (this.later.format('HH:mm:ss') !== '00:00:00') {
            setTimeout(() => {
              const temp = this.later.subtract('seconds', 1);
              this.later = this.$moment(temp);
              this.countdownTimes();
            }, 1000);
          } else {
            this.$store.commit('exam/saveFinish', {
              tf: true,
            });
            this.$store.dispatch('exam/calculationScore');
          }
        }
      }
    },
    totop() {
      if (this.single) {
        this.qkeyf = 1;
        this.qkeyf2 = 1;
      } else {
        this.$scrollTo(`#__q${1}`, 500, {
          offset: -130,
        });
        this.qkeyf = 1;
      }
    },
    noSingle() {
      this.$store.dispatch('exam/check', false);
    },
    isSingle() {
      this.$store.dispatch('exam/check', true);
    }
  },
  created() {
    this.isLoading = true;
    this.openAns = false;
  },
  mounted() {
    // const now = this.$moment().set('hour', 0);
    // now.set('minute', 0);
    // now.set('second', 0);
    // this.later = now.add(1, 'h');
    // this.later = now.add(20, 'm');
    this.retime();
    if (!this.allwaysAns) {
      this.countdownTimes();
    }
    const con = mem.QuestionsRecord();

    con.then((response) => {
      const formatYear = _.padStart(this.$route.params.year, 3, 0);
      let formatExamId = this.toZh[this.$route.params.examId.substr(0, 1)].name;
      let formatExamId2 = this.toZh[this.$route.params.examId.substr(2, 1)].name;
      let formatType = this.toZh[this.$route.params.examId.substr(1, 1)].name;
      if (formatYear >= 113) {
        formatExamId2 = (formatExamId2=='實務一')? '執業實務': (formatExamId2=='實務二')? '執業法規': formatExamId2;
        this.examTitle.name = formatYear + '年度' + formatExamId + formatType + '評量測驗' + ' ‧ ' + formatExamId2;
      } else {

        this.examTitle.name = formatYear + '年度專門職業及技術人員普通考試' + formatExamId + ' ‧ ' + formatExamId2;
      }
      
      this.examTitle.phoneName =  formatYear + '年度' + formatExamId + formatType + ' ‧ ' + formatExamId2;

      const isBuy = _.some(response.data.result, {
        exam_re: `EXAM_${formatYear}${this.$route.params.examId}`,
      });
      if (this.$route.params.method !== 'test') {
        if (isBuy) {
          //   this.$store.dispatch('indexPage/checkLogin');
          this.$store.dispatch('exam/getQuestons', {
            year: this.$route.params.year,
            type: this.$route.params.type,
            examId: this.$route.params.examId,
            method: this.$route.params.method,
          }).then(() => {
            this.isLoading = false;
          });
        } else {
          this.$router.push('/');
        }
      } else {
        this.$store.dispatch('exam/getQuestons', {
          year: this.$route.params.year,
          type: this.$route.params.type,
          examId: this.$route.params.examId,
          method: this.$route.params.method,
        }).then(() => {
          this.isLoading = false;
        });
      }
      // this.$store.commit('indexPage/changeLoading', false);
      // `EXAM_${formatYear}${this.$route.params.examId}`;
    });

    window.addEventListener('scroll', this.handleScroll);
  },
  watch: {
    openAns(value) {

      this.$store.commit('exam/setansStatus2', value);
    },
    openAna(value) {
      if (value) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },

  },
  computed: {
    isLoading_login: {
      get() {
        return this.$store.state.indexPage.isLoading_login;
      },
    },
    questionTag: {
      get() {
        return this.$store.state.exam.questionTag;
      },
    },
    ansStatus2: {
      get() {
        return this.$store.state.exam.ansStatus2;
      },
    },
    toZh: {
      get() {
        return this.$store.state.exam.toZh;
      },
    },
    AnalyzeTypeList: {
      get() {
        return this.$store.state.exam.AnalyzeTypeList;
      },
    },
    showDetial: {
      get() {
        return this.$store.state.exam.showDetial;
      },
      set(value) {
        this.$store.commit('exam/setAnalyzeTypeList', {
          type: 'all',
          mymethod: 'student',
        });
        this.$store.commit('exam/setShowDetail', value);
      },
    },
    allwaysAns: {
      get() {
        return this.$store.state.exam.allwaysAns;
      },
    },
    userInfo: {
      get() {
        return this.$store.state.indexPage.userinfo;
      },
    },
    AllAns: {
      get() {
        return this.$store.state.exam.questions.questionAns;
      },
    },
    status: {
      get() {
        return this.$store.state.indexPage.status;
      },
    },
    info: {
      get() {
        return this.$store.state.indexPage.loginInfo;
      },
    },
    selectedAns: {
      get() {
        return this.$store.state.exam.selectedAns;
      },
    },
    selectedStatus: {
      get() {
        return this.$store.state.exam.selectedStatus;
      },
    },
    totalQuestion: {
      get() {
        return this.$store.state.exam.questions.totalQuestion;
      },
    },
    unit_code_ob: {
      get() {
        const temp = {};
        _.uniq(this.questions2.map(e => e.unit_code.name)).forEach((item) => {
          temp[item] = {};
        });
        
        this.unit_code.forEach((e) => {
          let count = 0;
          let correct = 0;
          this.questions2.forEach((j) => {
            if (j.unit_code.name === e) {
              count += 1;
              temp[e].count = count;
              temp[e].name = e;
              if (this.AllAns[j.questionnumber - 1].ans[0] === this.selectedAns[j
                  .questionnumber - 1]) {
                correct += 1;

                temp[e].correct = correct;
              } else {
                temp[e].correct = correct;
              }
            }
          });

        });
        return temp;
      },
    },
    unit_code: {
      get() {
        return _.uniq(this.questions2.map(e => e.unit_code.name));
      },
    },
    isLogin: {
      get() {
        return this.$store.state.indexPage.isLogin;
      },
    },
    stopTimes: {
      get() {
        return this.$store.state.exam.stopTimes;
      },
    },
    questions2: {
      get() {
        return this.$store.state.exam.questions.result;
      },
    },
    single: {
      get() {
        return this.$store.state.exam.single;
      },
    },
    finish: {
      get() {
        return this.$store.state.exam.finish;
      },
    },
    score: {
      get() {
        const shownum = Math.round(this.$store.state.exam.score)
        const array1 = shownum.toString().split('');

        return {
          showall: shownum,
          split: array1
        };
      },
    },
    message1: {
      get() {
        return this.$store.state.exam.message;
      },
    },
    finishexam: {
      get() {
        return this.$store.state.exam.finish;
      }
    },
    times() {
      // console.log(this.$route)
      if (this.$route.params.type == "C"){
        return 60;
      } else {
        return 80;
      }
    }
  },
  async beforeRouteEnter(to, from, next) {
    if (to.params.method === 'test') {
      next();
    } else {
      const response = await store.dispatch('indexPage/checkLogin').then((response) => {
        return response.data;
      });

      if (response.status) {
        next();
      } else {
        next({
          name: 'index'
        })
      }
      // response.data.status ? (next()) : (next({name: 'index'}));
    }
    // next();
  },
  beforeRouteLeave(to, from, next) {
    store.commit('exam/clearAns');
    store.commit('exam/setTimes', false);
    store.commit('exam/saveFinish', {
      tf: false,
    });
    store.commit('exam/checksingle', false);
    store.commit('exam/setAllwaysAns', false);
    console.log(">>>>>");
    next();
  },
};
